import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { CheckedIcon } from "../icons/checked-icon";

interface IconCardSelectorProps {
  title: string;
  description?: string;
  selected?: boolean;
  onClick?: () => void;
}

const IconCardSelector = memo(function IconCardSelector({
  title,
  description,
  selected,
  onClick,
}: IconCardSelectorProps) {
  return (
    <button
      type="button"
      className={cn(
        "w-full flex flex-col justify-evenly items-start gap-3",
        "rounded-2xl p-4 cursor-pointer border bg-white",
        {
          "border-border-li-active": selected,
          "border-border-li-default": !selected,
        },
      )}
      onClick={onClick}
    >
      <div className="w-full flex items-center justify-between">
        <h5 className={cn(textVariants.listItemTitle)}>{title}</h5>
        {selected && <CheckedIcon className="fill-purple-700" />}
      </div>
      {description && (
        <p className={cn(textVariants.footnote, "text-left")}>{description}</p>
      )}
    </button>
  );
});

export default IconCardSelector;
